import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { EntityWithUrl, getSosEntityUrl } from "@/utils/sos/utilities";
import { Icon } from "./Icon";

export interface SosEntityLinkProps extends Omit<React.HTMLAttributes<HTMLAnchorElement>, "id" | "children" | "href"> {
  type: EntityWithUrl;
  id: number;
  label: React.ReactNode;
}

/**
 * Renders a link that navigates to an external page on SOS for a specific entity, based on the provided entity type and id.
 *
 * The label provided is rendered as-is, and the link is rendered adjacently as a small icon that opens in a new tab.
 *
 * Because the component is rendered this way, the label can actually be its own link, so we can both link internally and
 * externally to the SOS entity.
 */
export const SosEntityLink: React.FC<SosEntityLinkProps> = ({ type, id, label, ...anchorProps }) => {
  const href = getSosEntityUrl(type, id);

  return (
    <span className="text-nowrap">
      {label}{" "}
      <OverlayTrigger overlay={<Tooltip>View In SOS</Tooltip>}>
        <a href={href} target="_blank" rel="noreferrer" {...anchorProps}>
          <Icon icon="box-arrow-up-right" />
        </a>
      </OverlayTrigger>
    </span>
  );
};
